import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { ChatApiService } from './chat-api.service';
import { FeedbackRating } from '../models/chat.model';

@Injectable({
	providedIn: 'root',
})
export class FeedbackService {
	private feedbackMap = new BehaviorSubject<Map<string, FeedbackRating>>(new Map());

	constructor(private chatApi: ChatApiService) {}

	getFeedbackForMessage(messageId: string): FeedbackRating | undefined {
		return this.feedbackMap.value.get(messageId);
	}

	async submitFeedback(messageId: string, rating: 'thumbs_up' | 'thumbs_down', internalUserGUID: string, comment?: string): Promise<void> {
		try {
			await this.chatApi.submitFeedback({ feedback: { messageId, rating, comment, internalUserGUID } });
			const map = new Map(this.feedbackMap.value);
			map.set(messageId, { rating, comment, ratedAt: new Date() });
			this.feedbackMap.next(map);
		} catch (err) {
			console.error('Failed to submit feedback:', err);
		}
	}

	getFeedbackUpdates(): Observable<Map<string, FeedbackRating>> {
		return this.feedbackMap.asObservable();
	}
}
